import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SectionEditLink from './SectionEditLink';

const socialLinks = [
  { key: 'facebook', icon: ['fab', 'facebook'], label: 'Facebook' },
  { key: 'instagram', icon: ['fab', 'instagram'], label: 'Instagram' },
  { key: 'snapchat', icon: ['fab', 'snapchat'], label: 'Snapchat' },
  { key: 'twitter', icon: ['fab', 'twitter'], label: 'Twitter' },
  { key: 'tiktok', icon: ['fab', 'tiktok'], label: 'TikTok' },
];

function LinkOrText({ value, isLink }) {
  if (!value) return <span className="text-gray-400">Not set</span>;
  if (isLink) {
    return (
      <a href={value} target="_blank" rel="noopener noreferrer" className="text-primary hover:text-red-900 break-all">
        {value}
      </a>
    );
  }
  return <span>{value}</span>;
}

export default function ContactInfoPanel() {
  const listing = useSelector((s) => s.listings.selected);
  const contact = listing.contact || {};

  return (
    <div className="bg-white shadow overflow-hidden px-4 py-5 sm:rounded-lg sm:p-6">
      <div className="px-4 py-5 sm:px-6 flex items-start justify-between gap-4">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Contact Information
        </h3>
        <SectionEditLink section="contact" />
      </div>

      {/* Traditional */}
      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <h4 className="text-sm font-medium text-gray-900 px-6 pt-4 pb-2">Traditional</h4>
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Website</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              <LinkOrText value={contact.website} isLink />
            </dd>
          </div>
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Phone</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {contact.phone || <span className="text-gray-400">Not set</span>}
            </dd>
          </div>
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Email</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {contact.email ? (
                <a href={`mailto:${contact.email}`} className="text-primary hover:text-red-900">
                  {contact.email}
                </a>
              ) : (
                <span className="text-gray-400">Not set</span>
              )}
            </dd>
          </div>
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Reservation Link</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              <LinkOrText value={contact.reservationUrl} isLink />
            </dd>
          </div>
        </dl>
      </div>

      {/* Social */}
      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <h4 className="text-sm font-medium text-gray-900 px-6 pt-4 pb-2">Social</h4>
        <dl className="sm:divide-y sm:divide-gray-200">
          {socialLinks.map(({ key, icon, label }) => (
            <div key={key} className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500 flex items-center gap-2">
                <FontAwesomeIcon icon={icon} className="w-4" />
                {label}
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <LinkOrText value={contact[key]} isLink />
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
